export default {
  "b2b.provozni-informace-posledni-widget.label": "Poslední provozní informace",
  "b2b.provozni-informace-posledni-widget.cardNext": "DALŠÍ"
};
